import { Reveal } from "../lib/motion";
import { FAQ } from "../lib/data";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="relative py-28 md:py-36 bg-brand-surface border-y border-white/5">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20">
      <div className="lg:col-span-4">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-brand mb-4 flex items-center gap-3">
            <span className="w-8 h-px bg-brand" /> FAQ
          </p>
          <h2 className="font-display font-bold text-3xl sm:text-4xl md:text-5xl tracking-tight text-white leading-[1.05]">
            Häufige Fragen
          </h2>
          <p className="mt-6 text-white/60 leading-relaxed">
            Noch offene Punkte? Schreib uns einfach – wir beraten dich gerne persönlich.
          </p>
        </Reveal>
      </div>

      <div className="lg:col-span-8">
        <Reveal>
          <Accordion type="single" collapsible className="w-full">
            {FAQ.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-white/10">
                <AccordionTrigger data-testid={`faq-trigger-${i}`}
                  className="text-left font-display font-semibold text-lg md:text-xl text-white hover:text-brand hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-white/60 leading-relaxed text-base pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
